import { IllustrationNameType } from '@/resource/settings';
import styles from './Illustration.module.scss';
import { cx } from '@/util/cx';

type Props = {
  illustration: IllustrationNameType;
  width?: number;
  aspectRatio?: '16-9' | '1-1';
};

export function Illustration({
  illustration,
  width = 180,
  aspectRatio,
}: Props) {
  return (
    <picture
      className={cx(
        styles.Illustration,
        aspectRatio && styles[`aspect-ratio-${aspectRatio}`]
      )}
    >
      <img
        src={`/svg/illustration/nh_${illustration}.svg`}
        alt=""
        width={width}
      />
    </picture>
  );
}
